import { Component } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';

@Component({
  selector: 'app-renouvellement-refused-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule],
  templateUrl: './renouvellement-refused-dialog.component.html',
  styleUrl: './renouvellement-refused-dialog.component.scss',
})
export class RenouvellementRefusedDialogComponent {}
